module.exports = __webpack_public_path__ + "static/img/RAOK-1P-G.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RAOK-1P-G.png
// module id = ZPaG
// module chunks = 0